import React from 'react';
import { Calendar } from 'lucide-react';
import Dropdown from './Dropdown';

const DATE_OPTIONS = [
  { label: 'All Dates', value: 'all' },
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This Week', value: 'this_week' },
  { label: 'Last Week', value: 'last_week' },
  { label: 'This Month', value: 'this_month' },
  { label: 'Last Month', value: 'last_month' },
  { label: 'This Year', value: 'this_year' },
  { label: 'Last Year', value: 'last_year' }
];

const DateFilter = ({ value = 'all', onChange, style, label }) => {
  const options = DATE_OPTIONS.map(opt => ({
    ...opt,
    buttonRender: () => (label ? `${label}: ${opt.label}` : opt.label)
  }));

  return (
    <div style={{ minWidth: label ? '145px' : '120px', ...style }}>
      <Dropdown
        value={value}
        onChange={(val) => { if (onChange) onChange(val); }}
        options={options}
        icon={<Calendar size={14} style={{ color: 'var(--color-text-muted)', flexShrink: 0 }} />}
      />
    </div>
  );
};

export default DateFilter;
